<template>
    <div>
        <a href="#" v-if="!hideLink" v-b-modal.order-a-call-modal> {{ $t('general.order_a_call') }} </a>
        <b-modal
            id="order-a-call-modal"
            title="Order a call"
            centered
            hide-footer
            :content-class="'order-a-call-form'">
            <div v-if="formSubmitted" class="text-center">
                <div class="d-inline-block checked-mark circle small mb-4">
                    <i class="fas fa-check center"></i>
                </div>
                <p>{{$t('general.order_a_call_from_submitted_line_1')}}</p>
                <p>{{$t('general.order_a_call_from_submitted_line_2')}}</p>
            </div>
            <div v-else>
                <h1>{{ $t('general.order_a_call') }}</h1>
                <form @submit.prevent="submit">
                        <google-recaptcha-v3
                            v-on:input="updateRecaptcha"
                            ref="captchaOrderACall"
                            :site-key="this.$recaptchaKey"
                            id="order_a_call_id"
                            action="order_a_call"
                        ></google-recaptcha-v3>
                        <input-with-validation
                            :value="item.phone"
                            :title="$t('fields.phone')"
                            :name="'phone'"
                            :style-class="'form-control'"
                            :type="'text'"
                            :errors="errors"
                            :use-u-i-d="true"
                            :name-type="'placeholder'"
                            @onInput="changePhone"/>
                        <input-with-validation
                            :value="item.company"
                            :title="$t('fields.company')"
                            :name="'company'"
                            :style-class="'form-control'"
                            :type="'text'"
                            :errors="errors"
                            :use-u-i-d="true"
                            :name-type="'placeholder'"
                            @onInput="changeCompany"/>
                        <input-with-validation
                            :value="item.message"
                            :title="$t('fields.message_question')"
                            :name="'message'"
                            :style-class="'form-control'"
                            :type="'textarea'"
                            :errors="errors"
                            :use-u-i-d="true"
                            :name-type="'placeholder'"
                            :rows="'3'"
                            @onInput="changeMessage"/>

                        <div class="checkbox-container d-flex align-items-center">
                            <input-with-validation
                                :value="item.accept"
                                :checkboxMessage="$t('fields.i_agree_to_the')"
                                :checkboxMessage2="$t('fields.accept_terms_of_service')"
                                :name="'accept'"
                                :style-class="'regular-checkbox check-small'"
                                :mainDivClass="'checkbox form-check check-small d-inline-flex'"
                                :type="'custom-checkbox'"
                                :errors="errors"
                                :use-u-i-d="true"
                                @onInput="changeAccept"
                                hide-label
                            />
                            <span class="ml-2 checkbox">
                                <span>{{$t('fields.i_agree_to_the')}}</span>
                                <span><a href="javascript:void(0)" @click="onTermsAndConditionsClick">{{$t('fields.accept_terms_of_service')}}</a></span>
                            </span>
<!--                            @click="$bvModal.show('terms-and-conditions-modal')"-->
                        </div>

                        <div class="custom-error-message" v-if="errors && errors.error_message">
                            <p>{{errors.error_message}}</p>
                        </div>
                        <button type="submit" class="btn btn-primary w-100 btn-big" :disabled="loading">
                            <span v-if="!loading">
                                {{ $t('general.confirm')}}
                            </span>

                            <div class="spinner-border loading-spinner" role="status" v-if="loading">
                                <span class="sr-only"></span>
                            </div>
                        </button>
                </form>
            </div>
            <button type="button" aria-label="Close" class="close modal-close" style="display: none" @click="$bvModal.hide('order-a-call-modal')">×</button>
        </b-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import GoogleRecaptchaV3 from "../../components/googlerecaptchav3/GoogleReCaptchaV3";
    import Vue from 'vue';

    export default {
        components: {GoogleRecaptchaV3},
        props: {
            hideLink: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                data: [],
                formSubmitted: false,
                errors: null,
            }
        },
        computed: {
            ...mapGetters('OrderACallFormSingle', ['item', 'loading']),
        },
        created() {
            var app = this;
            this.$vueEventBus.$on('clear-errors', function () {
                app.errors = null;
            });
        },
        methods: {
            ...mapActions('OrderACallFormSingle', ['send', 'setPhone', 'setCompany', 'setMessage', 'setAccept', 'resetState', 'setgRecaptchaResponse']),
            changePhone(event) {
                this.setPhone(event.target.value);
            },
            changeCompany(event) {
                this.setCompany(event.target.value);
            },
            changeMessage(event) {
                this.setMessage(event.target.value);
            },
            changeAccept(event) {
                this.setAccept(event.target.checked ? 1 : 0);
            },
            updateRecaptcha(response) {
                this.setgRecaptchaResponse(response);
            },
            submit() {
                this.send().then(response => {
                    this.formSubmitted = true;
                    this.$refs.captchaOrderACall.execute();
                }).catch(error => {
                    this.errors = error.response.data.errors;
                    if (typeof this.errors === "undefined") {
                        this.errors = {};
                    }
                    if(error.response.data.error_message) {
                        Vue.set(this.errors,'error_message',error.response.data.error_message);
                    }
                    this.$refs.captchaOrderACall.execute();
                })
            },
            onTermsAndConditionsClick(event) {
                this.$emit('onTermsAndConditionsClick', event);
            },
        }
    }
</script>
